module.exports = __webpack_public_path__ + "img/CX.bfd42986.png";